import React, { useState, useEffect } from 'react';
import { Carousel, Col, Row, Image, Divider } from 'antd';
import LoadingEmptyComponent from '../../components/LoadingEmptyComponent/LoadingEmptyComponent';
import { errorNotification } from '../../utils/Notification';
import { getRandomApps } from '../../services/client';
import './Home.css';
import {
  GithubOutlined,
  HomeOutlined,
  SettingOutlined
} from '@ant-design/icons';

const Home = () => {
  const [cardContent, setCardContent] = useState([]);
  const [fetching, setFetching] = useState(true);

  const fetchRandomApps = () => {
    getRandomApps()
      .then((res) => res.json())
      .then((data) => {
        setCardContent(data);
      })
      .catch((err) => {
        console.log(err.response);
        err.response.json().then((res) => {
          console.log(res);
          errorNotification(
            "There was an issue",
            `${res.message} [${res.status}] [${res.error}]`
          );
        });
      })
      .finally(() => setFetching(false));
  };

  useEffect(() => {
    fetchRandomApps();
  }, []);

  return (
    <>
      <div style={{ minHeight: '100vh',
  textAlign: 'center'}}>
        <Divider orientation="center" orientationMargin="150"><h1 className="custom-header-home">App Showcase</h1></Divider>
        <Carousel dotPosition={'top'} autoplay centerMode centerPadding="2">
          {Array.isArray(cardContent) && cardContent.length > 0 ? (
            cardContent.map((card, index) => (
              <div key={index} className="contentStyle" >
                <Row>
                  <Col span={24} className="col-basic"></Col>
                </Row>
                <Row>
                  <Col span={6} className="col-basic"></Col>
                  <Col span={8} className="col-basic">
                    <Image 
                      src={card.logo}
                      preview={false}
                    /></Col>
                  <Row>
                    <Col span={6} className="col-left-basic"></Col>
                  </Row>
                  <Col span={8}  className="col-left">
                    <h2 className="custom-header-home">{card.name}</h2>
                    <Divider orientation="left"></Divider>
                    <h3 className='custom-header-home'>{card.description}</h3>
                    <Divider orientation="left"></Divider>
                    <Row justify="space-evenly">
                      <Col span={4}><a href={card.githubRepo} target="_blank" rel="noopener noreferrer">
                        <GithubOutlined />
                      </a></Col>
                      <Col span={4}><a href={card.website} target="_blank" rel="noopener noreferrer">
                        <HomeOutlined />
                      </a></Col>
                      <Col span={4}><a href="/manage" rel="noopener noreferrer">
                        <SettingOutlined />
                      </a></Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col span={24} className="col-mini"></Col>
                </Row>
              </div>
            ))
          ) : (
            <div>
              <LoadingEmptyComponent
                loading={fetching}
                data={cardContent}
              />
            </div>
          )}
        </Carousel>
      </div>
    </>
  );
};

export default Home;
